<ng-template [ngIf]="status">
    <span [class]="status | pessoaTermoLGPDStatusBadge">
        {{status | pessoaTermoLGPDStatus}}
    </span>
</ng-template>